export { default as InstallmentNonActiveModal } from "./installment-non-active-modal";
